import { DmPassSubscriptionTargetInterface, PassTargetTypeEnum } from '../../..';

export class DmPassSubscriptionTargetDto implements DmPassSubscriptionTargetInterface{
  targetId: string;
  targetType: PassTargetTypeEnum;
}
